import React, { createContext, useContext, useState } from 'react';
import { DishStoryViewer } from '@/components/story/DishStoryViewer';

interface DishStoryState {
  dishId: string | null;
  thumbnailRect: DOMRect | null;
}

interface DishStoryContextType {
  openDishStory: (dishId: string, thumbnailRect?: DOMRect) => void;
}

const DishStoryContext = createContext<DishStoryContextType>({
  openDishStory: () => {},
});

export const useDishStory = () => useContext(DishStoryContext);

export const DishStoryProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [state, setState] = useState<DishStoryState>({ dishId: null, thumbnailRect: null });

  const openDishStory = (dishId: string, thumbnailRect?: DOMRect) => {
    setState({ dishId, thumbnailRect: thumbnailRect ?? null });
  };

  const handleClose = () => {
    setState({ dishId: null, thumbnailRect: null });
  };

  return (
    <DishStoryContext.Provider value={{ openDishStory }}>
      {children}
      <DishStoryViewer
        dishId={state.dishId}
        thumbnailRect={state.thumbnailRect}
        onClose={handleClose}
      />
    </DishStoryContext.Provider>
  );
};
